import React, { useState } from 'react';
import { apis, models } from "@vote4dance/judging-sdk";
var Api = apis.Api;
var CompetitionUsersSource = models.users.CompetitionUsersSource;
var UserCompetitionItem = models.users.UserCompetitionItem;
import { SearchUser } from '../../base-react/components/SearchUser';
import { Badge } from 'antd';
export const SearchCompetitionUser = ({ event_id, callback, disabled }) => {
    const [items, setItems] = useState([]);
    const competitionUsersSource = CompetitionUsersSource(event_id);
    const onFilter = async (text) => {
        if (text.length >= 3) {
            const result = await Api.call(competitionUsersSource.url, 'find', { term: text });
            setItems(result);
            return result ? result.map(item => ({
                value: item.user_email,
                label: React.createElement(React.Fragment, null,
                    `${UserCompetitionItem.getFullName(item)} (${item.user_email})`,
                    " ",
                    React.createElement(Badge, null,
                        item.competition_count,
                        "x"))
            })) : [];
        }
        return [];
    };
    const onFinish = async (value, done) => {
        callback(items.find(a => a.user_email === value));
        done();
    };
    return React.createElement(SearchUser, { onFilter: onFilter, onFinish: onFinish, disabled: disabled });
};
